var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApiActivation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 7C11.25 5.48122 12.4812 4.25 14 4.25H16.75V5.75H18.5C18.9142 5.75 19.25 6.08579 19.25 6.5C19.25 6.91421 18.9142 7.25 18.5 7.25H16.75V8.75H18.5C18.9142 8.75 19.25 9.08579 19.25 9.5C19.25 9.91421 18.9142 10.25 18.5 10.25H16.75V11.75H14C12.4812 11.75 11.25 10.5188 11.25 9V7ZM15.25 10.25V5.75H14C13.3096 5.75 12.75 6.30964 12.75 7V9C12.75 9.69036 13.3096 10.25 14 10.25H15.25ZM4.25 11.75C4.25 9.26472 6.26472 7.25 8.75 7.25H9C9.41421 7.25 9.75 7.58579 9.75 8C9.75 8.41421 9.41421 8.75 9 8.75H8.75C7.09315 8.75 5.75 10.0931 5.75 11.75C5.75 13.4069 7.09315 14.75 8.75 14.75H16.75C18.4069 14.75 19.75 16.0931 19.75 17.75C19.75 19.4069 18.4069 20.75 16.75 20.75H11.5V19.25H16.75C17.5784 19.25 18.25 18.5784 18.25 17.75C18.25 16.9216 17.5784 16.25 16.75 16.25H8.75C6.26472 16.25 4.25 14.2353 4.25 11.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiActivation);
export default __webpack_public_path__ + "static/media/api-activation.88a897ac.svg";
export { ForwardRef as ReactComponent };